import { createSlice } from '@reduxjs/toolkit'

// Session lifecycle generation, independent of the store composition root so
// request-time code (request.js and slice payload creators) can capture and
// compare the generation without importing store.js (which would be circular).
//
// `invalidateSession()` is the only sanctioned dispatcher: it increments a
// module-level counter AND dispatches the slice action, so the mutable mirror
// (`getCurrentSessionGeneration`) and the Redux state always move together.
// Old-generation responses and obsolete-token 401s are then detectable from
// anywhere without holding the store reference.

export const sessionSlice = createSlice({
    name: 'session',
    initialState: {
        generation: 0,
    },
    reducers: {
        sessionInvalidated(state, action) {
            state.generation = action.payload
        },
    },
})

export const { sessionInvalidated } = sessionSlice.actions

export const selectSessionGeneration = state => state.session.generation

let currentGeneration = 0

export function invalidateSession() {
    currentGeneration += 1
    return sessionInvalidated(currentGeneration)
}

export function getCurrentSessionGeneration() {
    return currentGeneration
}

export function isCurrentSessionGeneration(generation) {
    return generation === currentGeneration
}

export function resetSessionGenerationForTests() {
    currentGeneration = 0
}